import React from 'react'
import './NewForcast.css'
import newf1 from '../../images/newf1.png'
import newf2 from '../../images/newf2.png'
import newf3 from '../../images/newf3.png'
import newf4 from '../../images/newf4.png'
import newf5 from '../../images/newf5.png'
import newf6 from '../../images/newf6.png'
import RiskByBusinessUnit from './RiskByBusinessUnit/RiskByBusinessUnit'
import AnalyticsChart from './AnalyticsChart/AnalyticsChart'
import AverageRiskChart from './AverageRiskChart/AverageRiskChart'
import RelationshipsContent from './RelationshipsContent/RelationshipsContent'
const NewForcast = () => {
  return (
    <div className='new_forcast_page'>
        <div className='new_forcast_left'>
             <h4>Status</h4>
             <div className='new_sd_div'>
                <img src={newf3}/>
                <p>Insights</p>
             </div>
              <div className='new_sd_div'>
                <img src={newf4}/>
                <p>Annalytics</p>
             </div>
              <div className='new_sd_div'>
                <img src={newf5}/>
                <p>Resource</p>
             </div>
              <div className='new_sd_div'>
                <img src={newf2}/>
                <p>Reletionship</p>
             </div>
              <div className='new_sd_div'>
                <img src={newf6}/>
                <p>Business Explore</p>
             </div>
             <div className='new_sd_div'>
                <img src={newf1}/>
                <p>Chat monitor</p>
             </div>
        </div>
        <div className='new_forcast_right'>
              <div className='progess_chart_head'>
                 <div> <h2 className='pr_ch_title'>Progress Chart</h2></div>
                  <div className='progess_chart_head_end_wrp'>
                      <div className="toolbar_wrapper_fc">
                        <div className="toolbar_item_fc toolbar_date_fc">
                          <i className="fa-regular fa-calendar toolbar_icon_fc"></i>
                          <span>Nov 21 – Nov 30</span>
                        </div>
                        <div className="toolbar_item_fc toolbar_month_fc">
                          <span>Monthly</span>
                          <i className="fa-solid fa-chevron-down toolbar_icon_fc"></i>
                        </div>
                        <div className="toolbar_item_fc">
                          <i className="fa-solid fa-sliders toolbar_icon_fc"></i>
                          <span>Filter</span>
                        </div>
                        <div className="toolbar_item_fc">
                          <i className="fa-solid fa-arrow-up-from-bracket toolbar_icon_fc"></i>
                          <span>Export</span>
                        </div>

                      </div>
                      <div className='newse_btn_fc_wrp'>
                          <button className='newse_btn_fc'>New Features </button>
                          <button className='newse_btn_fc'>Select User</button>
                      </div>
                  </div>
              </div>

              <div className="risk_tabs_wrapper_fc">
                <div className="risk_tabs_left_fc">
                  <button className="risk_tab_fc risk_tab_active_fc">
                    RISK METRICS
                  </button>

                  <button className="risk_tab_fc">
                    PROGRAM METRICS
                  </button>

                  <button className="risk_tab_fc">
                    RISK NETWORK
                  </button>
                </div>

                <div className="risk_search_wrapper_fc">
                  <input
                    type="text"
                    placeholder="Search"
                    className="risk_search_input_fc"
                  />
                  <i className="fa-solid fa-magnifying-glass risk_search_icon_fc"></i>
                </div>
              </div>
              <div className='unit_chart_wrp'>
                 <div className='risk_wrp_div'>
                   <RiskByBusinessUnit/>
                 </div>
                 <div className='analytics_wrp_div'>
                   <AnalyticsChart/>
                 </div>
              </div>
              <div>
                <AverageRiskChart/>
              </div>
               <RelationshipsContent/>
        </div>
    </div>
  )
}

export default NewForcast